export default "__VITE_ASSET__CI_f2jW$__"